const Products = () => import("@/components/alfred/ProductsList.vue");
const Issues = () => import("@/components/alfred/IssuesList.vue");

export default [
  {
    path: "",
    name: "Products",
    component: Products,
  },
  {
    path: "issues",
    component: Issues,
  },
];
